import { useTranslation } from "react-i18next";

function ThermostatWarning({
  onClose,
  title = "Thermostat placement",
  message = "We do not recommend placing thermostats on top, behind, or near cold spots.",
}) {
  const { t } = useTranslation();

  return (
    <aside
      className="thermostat-warning"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="thermostat-warning__icon" aria-hidden="true">
        !
      </span>
      <div className="thermostat-warning__content">
        <strong>{t(title)}</strong>
        <span>{t(message)}</span>
      </div>
      <button
        type="button"
        className="thermostat-warning__close"
        onClick={onClose}
        aria-label={t("Close")}
      >
        ×
      </button>
    </aside>
  );
}

export default ThermostatWarning;
